// DO NOT MODIFY! THIS FILE IS AUTOGENERATED BY generate-endpoint-spec.util.ts

import { RequestHandler } from 'express';

export const TSpecRoute_submitLibraryDocFeedback = (path: TSpecPathSubmitLibraryDocFeedback) => {
  let res = "/library/docs/:libraryDocId/feedback";
  Object.entries(path).map(([key, value]) => {
    res = res.replace(':' + key, value);
  });
  return res;
};

export type TSpecHandler_submitLibraryDocFeedback = RequestHandler<TSpecPathSubmitLibraryDocFeedback, any, TSpecBodySubmitLibraryDocFeedback, TSpecQuerySubmitLibraryDocFeedback, {}>;

export interface TSpecPathSubmitLibraryDocFeedback { libraryDocId: string; }

export interface TSpecBodySubmitLibraryDocFeedback {
  /**
   * Feedback message
   */
  message: string;
}

export interface TSpecQuerySubmitLibraryDocFeedback {
  AppVersion?: string;
  AppUser?: string;
}
